import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Dropdown, Tooltip } from "antd";
import Scrollbar from "../tools/common/Scrollbar";
import i18n from "i18next";
import { connect } from "react-redux";

class ToolBar extends Component {
  static propTypes = {
    canvasRef: PropTypes.any,
    onChangeSelectedProperties: PropTypes.func,
    zoneActive: PropTypes.bool,
  };

  getCanvasHandler = () => {
    return this.props.canvasRef?.handler || null;
  };

  handleSelectItem = (type, tool) => {
    const { onChangeSelectedProperties } = this.props;
    if (onChangeSelectedProperties) {
      onChangeSelectedProperties(type, tool);
    }
  };

  handleDrawing = (objectType) => {
    const handler = this.getCanvasHandler();
    if (!handler) return;

    handler.drawingHandler.setType(objectType);
    handler.drawingHandler.onInit();
  };

  runInteractionAction = (mode, callback) => {
    const handler = this.getCanvasHandler();

    if (!handler) return;
    if (handler.interactionHandler.isDrawingMode()) return;

    callback(handler);
    handler.drawingHandler.selectedType = "";
  };

  onClickHandler = (objectType) => {
    const handler = this.getCanvasHandler();
    if (!handler) return;

    handler.deleteIncompletePolygon();
    handler.canvas.discardActiveObject();

    switch (objectType) {
      case "seatSelector":
        return this.runInteractionAction("seatSelection", (currentHandler) => {
          currentHandler.interactionHandler.seatSelection();
        });

      case "selection":
        return this.runInteractionAction("selection", (currentHandler) => {
          currentHandler.interactionHandler.selection();
        });

      case "move":
        return this.runInteractionAction("grab", (currentHandler) => {
          currentHandler.interactionHandler.grab();
        });

      default:
        this.handleSelectItem("menu", objectType);
        return this.handleDrawing(objectType);
    }
  };

  getSeatTools = () => [
    {
      key: "row",
      label: i18n.t("mapeditor.tools.row"),
      iconClass: "icon-tool-seats",
      iconStyle: { fontSize: "6px" },
    },
    {
      key: "multipleRows",
      label: i18n.t("mapeditor.tools.multipleRows"),
      iconClass: "icon-tool-row-seats",
      iconStyle: { fontSize: "21px" },
    },
  ];

  getTableTools = () => [
    {
      key: "roundTable",
      label: i18n.t("mapeditor.tools.circularTable"),
      iconClass: "icon-tool-circular-table",
      iconStyle: { fontSize: "27px" },
    },
    {
      key: "rectTable",
      label: i18n.t("mapeditor.tools.rectTable"),
      iconClass: "icon-tool-rectangle-table",
      iconStyle: { fontSize: "24px", marginLeft: "1.5rem" },
    },
  ];

  getZoneTools = () => [
    {
      key: "polygonZone",
      label: i18n.t("mapeditor.tools.polygonZone"),
      iconClass: "icon-tool-polygone-zone",
      iconStyle: { fontSize: "24px" },
    },
  ];

  getShapeTools = () => [
    {
      key: "ellipse",
      label: "Elipse",
      iconClass: "icon-tool-circle",
      iconStyle: { fontSize: "21px" },
    },
    {
      key: "rect",
      label: i18n.t("mapeditor.tools.rect"),
      iconClass: "icon-tool-rectangle",
      iconStyle: { fontSize: "21px" },
    },
    {
      key: "triangle",
      label: i18n.t("mapeditor.tools.triangle"),
      iconClass: "icon-tool-triangle",
      iconStyle: { fontSize: "21px" },
    },
    {
      key: "polygon",
      label: i18n.t("mapeditor.tools.polygon"),
      iconClass: "icon-tool-polygon",
      iconStyle: { fontSize: "21px" },
    },
  ];

  renderDropdownMenu = (tools) => (
    <ul className="dropdown-objects">
      {tools.map((tool) => (
        <li key={tool.key}>
          <Button onClick={() => this.onClickHandler(tool.key)}>
            <small>{tool.label}</small>
            <span className={tool.iconClass} style={tool.iconStyle}></span>
          </Button>
        </li>
      ))}
    </ul>
  );

  renderToolButton = ({
    title,
    objectType,
    iconClass,
    iconStyle,
    wrapperElement = "div",
    extraClassName = "",
    children = null,
  }) => {
    const WrapperTag = wrapperElement;
    const className = ["map-editor-toolbar-item-icon", extraClassName]
      .filter(Boolean)
      .join(" ");

    return (
      <Tooltip title={title} placement="right">
        <WrapperTag
          className={className}
          onClick={() => this.onClickHandler(objectType)}
        >
          {children || <span className={iconClass} style={iconStyle}></span>}
        </WrapperTag>
      </Tooltip>
    );
  };

  renderDropdownButton = ({
    overlay,
    iconClass,
    iconStyle,
    className = "map-objectsBar__btns",
  }) => (
    <div className={className}>
      <Dropdown overlay={overlay} placement="bottomRight" trigger={["hover"]}>
        <Button>
          <span className={iconClass} style={iconStyle}></span>
        </Button>
      </Dropdown>
    </div>
  );

  render() {
    const { zoneActive } = this.props;

    const seatTools = this.getSeatTools();
    const tableTools = this.getTableTools();
    const shapeTools = this.getShapeTools();

    return (
      <article className="content_toolbar">
        <Scrollbar>
          <div
            style={{
              overflowY: "hidden",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {this.renderToolButton({
              title: i18n.t("mapeditor.tools.cursorDefault"),
              objectType: "selection",
              iconClass: "icon-cursor-default",
              iconStyle: { fontSize: "18px" },
            })}

            {this.renderToolButton({
              title: "Selector de asientos",
              objectType: "seatSelector",
              iconClass: "icon-selector-seats",
              iconStyle: { fontSize: "18px" },
            })}

            {this.renderToolButton({
              title: i18n.t("mapeditor.tools.cursorDragging"),
              objectType: "move",
              iconClass: "icon-tool-hand",
              iconStyle: { fontSize: "18px" },
            })}

            {this.renderDropdownButton({
              overlay: this.renderDropdownMenu(seatTools),
              iconClass: "icon-icon-seat",
              className: "map-objectsBar__btns xxx",
            })}

            {this.renderDropdownButton({
              overlay: this.renderDropdownMenu(tableTools),
              iconClass: "icon-tool-tables",
              iconStyle: { fontSize: "24px" },
            })}

            {!zoneActive && (
              <>
                {/* {this.renderDropdownButton({
                  overlay: this.renderDropdownMenu(zoneTools),
                  iconClass: "icon-tool-zones",
                  iconStyle: { fontSize: "21px" },
                })} */}

                {this.renderDropdownButton({
                  overlay: this.renderDropdownMenu(shapeTools),
                  iconClass: "icon-tool-shapes",
                  iconStyle: { fontSize: "21px" },
                })}

                {this.renderToolButton({
                  title: i18n.t("mapeditor.tools.text"),
                  objectType: "text",
                  iconClass: "icon-tool-text",
                  iconStyle: { fontSize: "21px" },
                  wrapperElement: "span",
                })}

                {this.renderToolButton({
                  title: i18n.t("mapeditor.tools.icons"),
                  objectType: "svg",
                  wrapperElement: "span",
                  children: (
                    <span className="icon-tool-icons">
                      <span className="path1"></span>
                      <span className="path2"></span>
                      <span className="path3"></span>
                      <span className="path4"></span>
                      <span className="path5"></span>
                      <span className="path6"></span>
                      <span className="path7"></span>
                    </span>
                  ),
                })}
              </>
            )}
          </div>
        </Scrollbar>
      </article>
    );
  }
}

const mapStateToProps = (state) => ({
  zoneActive: state.properties.zoneActive,
});

export default connect(mapStateToProps)(ToolBar);